import { Group, Paper, Switch } from '@common/ui'
import { com } from '@eidu/web'
import { withKey } from '../../util/withKey'
import FormKeyField from './FormKeyField'
import TrimmedTextInput from './TrimmedTextInput'
import MultiLine = com.eidu.sharedlib.form.definition.MultiLine

type MultiLineItemProps = {
  item: MultiLine
  onChange?: (newItem: MultiLine) => void
  onDelete?: () => void
}

const MultiLineItem: React.FC<MultiLineItemProps> = ({ item, onChange }) => (
  <Paper withBorder radius="sm" p="xs">
    <Group gap="md" wrap="nowrap" align="flex-start">
      <TrimmedTextInput
        style={{ flex: 1 }}
        value={item.prompt}
        onChange={(e) => onChange?.(withKey(item.copy(e.target.value, item.key, item.required), item))}
        placeholder="Enter prompt"
        label="Prompt"
        disabled={!onChange}
      />
      <FormKeyField
        value={item.key}
        onChange={(e) => onChange?.(withKey(item.copy(item.prompt, e.target.value, item.required), item))}
        disabled={!onChange}
      />
      <Switch
        checked={item.required}
        onChange={(e) => onChange?.(withKey(item.copy(item.prompt, item.key, e.target.checked), item))}
        disabled={!onChange}
        label="Required"
      />
    </Group>
  </Paper>
)

export default MultiLineItem
